/*********************************************************************
 * © Copyright IBM Corp. 2022
 * Copyright © 2022 Randori https://randori.com - All Rights Reserved.
 *********************************************************************/

// Object.keys, but with the correct types
export function keys<T>(object: Record<keyof T, unknown>) {
  return Object.keys(object) as (keyof T)[]
}
